import { SortOrder, SortAs } from '@ocean/types/dist/sort'
import { SortUtils } from '@ocean/utils'
import {
  SimulatorExercise,
  SimulatorExerciseTypeReference,
} from 'modules/simulatorTrainings/instructor/studentLed/ExerciseList/types'

class ExerciseListUtils {
  getExercisesTypes(simulators: SimulatorExercise[]): SimulatorExerciseTypeReference[] {
    let typesObj: Record<string, string> = {}

    simulators.forEach(({ type }) => {
      if (!typesObj[type]) typesObj[type] = type
    })

    // TODO: Migration on DictionariesUtils.createDictionaryFromObject?
    const references = Object.keys(typesObj).map(type => ({
      id: type,
      name: typesObj[type],
    }))

    return [...references].sort(
      SortUtils.sortByMultipleKeys(['name'], SortOrder.Ascending, SortAs.String)
    )
  }
}

export default new ExerciseListUtils()
